import { Game } from "@/components/nflSchedules/types";

export function gamesByTotalDesc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    if (game2?.odds?.home?.total?.value || game1?.odds?.home?.total?.value) {
      if (!game2?.odds?.home?.total?.value) {
        return -1;
      }

      if (!game1?.odds?.home?.total?.value) {
        return 1;
      }
      return (
        Number.parseFloat(game2.odds.home.total.value.split(" ")[1]) -
        Number.parseFloat(game1.odds.home.total.value.split(" ")[1])
      );
    }

    if (game2?.closingLines?.total && game1?.closingLines?.total) {
      return (
        Number.parseFloat((game2?.closingLines?.total ?? "0").toString()) -
        Number.parseFloat((game1?.closingLines?.total ?? "0").toString())
      );
    }

    if (!game2?.closingLines?.total && !game1?.closingLines?.total) {
      return 0;
    }
    if (!game2?.closingLines?.total) {
      return -1;
    }

    if (!game1?.closingLines?.total) {
      return 1;
    }
    return 0;
  });
}

export function gamesByTotalAsc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    if (game2?.odds?.home?.total?.value || game1?.odds?.home?.total?.value) {
      if (!game2?.odds?.home?.total?.value) {
        return -1;
      }

      if (!game1?.odds?.home?.total?.value) {
        return 1;
      }

      return (
        Number.parseFloat(
          (game1?.odds?.home?.total?.value ?? "0").toString().split(" ")[1]
        ) -
        Number.parseFloat(
          (game2?.odds?.home?.total?.value ?? "0").toString().split(" ")[1]
        )
      );
    }
    if (game2?.closingLines?.total && game1?.closingLines?.total) {
      return (
        Number.parseFloat((game1?.closingLines?.total ?? "0").toString()) -
        Number.parseFloat((game2?.closingLines?.total ?? "0").toString())
      );
    }

    if (!game2?.closingLines?.total && !game1?.closingLines?.total) {
      return 0;
    }
    if (!game2?.closingLines?.total) {
      return -1;
    }

    if (!game1?.closingLines?.total) {
      return 1;
    }
    return 0;
  });
}

export function gamesBySpreadAsc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    if (game2?.odds?.home?.spread?.value || game1?.odds?.home?.spread?.value) {
      if (!game2?.odds?.home?.spread?.value) {
        return -1;
      }

      if (!game1?.odds?.home?.spread?.value) {
        return 1;
      }
      return (
        Math.abs(Number.parseFloat(game1.odds.home.spread.value.toString())) -
        Math.abs(Number.parseFloat(game2.odds.home.spread.value.toString()))
      );
    }
    if (game1?.closingLines?.spread && game2?.closingLines?.spread) {
      return (
        Math.abs(
          Number.parseFloat((game1?.closingLines?.spread ?? "0").toString())
        ) -
        Math.abs(
          Number.parseFloat((game2?.closingLines?.spread ?? "0").toString())
        )
      );
    }
    if (!game2?.closingLines?.spread && !game1?.closingLines?.spread) {
      return 0;
    }
    if (!game2?.closingLines?.spread) {
      return -1;
    }

    if (!game1?.closingLines?.spread) {
      return 1;
    }
    return 0;
  });
}

export function gamesBySpreadDesc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    if (game2?.odds?.home?.spread?.value || game1?.odds?.home?.spread?.value) {
      if (!game2?.odds?.home?.spread?.value) {
        return -1;
      }

      if (!game1?.odds?.home?.spread?.value) {
        return 1;
      }
      return (
        Math.abs(Number.parseFloat(game2.odds.home.spread.value.toString())) -
        Math.abs(Number.parseFloat(game1.odds.home.spread.value.toString()))
      );
    }

    if (game1?.closingLines?.spread && game2?.closingLines?.spread) {
      return (
        Math.abs(
          Number.parseFloat((game2?.closingLines?.spread ?? "0").toString())
        ) -
        Math.abs(
          Number.parseFloat((game1?.closingLines?.spread ?? "0").toString())
        )
      );
    }
    if (!game2?.closingLines?.spread && !game1?.closingLines?.spread) {
      return 0;
    }
    if (!game2?.closingLines?.spread) {
      return -1;
    }

    if (!game1?.closingLines?.spread) {
      return 1;
    }
    return 0;
  });
}

export function gamesByMarginDesc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    const game1Margin = Math.max(
      game1?.homeTeam?.winProbability ?? 0,
      game1?.awayTeam?.winProbability ?? 0
    );
    const game2Margin = Math.max(
      game2?.homeTeam?.winProbability ?? 0,
      game2?.awayTeam?.winProbability ?? 0
    );

    return game2Margin - game1Margin;
  });
}

export function gamesByMarginAsc(sortableGames: Game[]) {
  return sortableGames.sort((game1, game2) => {
    const game1Margin = Math.max(
      game1?.homeTeam?.winProbability ?? 0,
      game1?.awayTeam?.winProbability ?? 0
    );
    const game2Margin = Math.max(
      game2?.homeTeam?.winProbability ?? 0,
      game2?.awayTeam?.winProbability ?? 0
    );

    return game1Margin - game2Margin;
  });
}
